<template>
	<v-card>
		<v-card-text>
			<recordatorios
				:datos="valor"
				:validateForm="validar"
				@valorCambiado="valorCambiado"
				:esVisita="true"
			></recordatorios>
			<v-footer app class="pt-3 d-print-none">
				<v-btn color="secondary" x-large @click.prevent="regresar"
					>Regresar <v-icon>chevron_left</v-icon></v-btn
				>
				<v-spacer></v-spacer>
				<v-btn color="primary" x-large @click.prevent="guardar"
					><v-icon>save</v-icon> Guardar
				</v-btn>
			</v-footer>
		</v-card-text>
	</v-card>
</template>

<script>
import Recordatorios from "../historial-clinico/recordatorios.vue";
import ServicioVisita from "../../../services/visita";
export default {
	components: { Recordatorios },
	name: "dieteticosYEstiloVida",
	data() {
		return {
			valor: null,
			validar: false
		};
	},
	async mounted() {
		await this.obtenerInfoPaso();
	},
	methods: {
		async obtenerInfoPaso() {
			const nombrePaso = "DieteticosEstiloVida";
			const res = await ServicioVisita.obtenerInfoPaso(
				nombrePaso,
				this.visitaId
			);
			if (res.data.result === 1 && res.data.data.Table0.length) {
				const valor = JSON.parse(res.data.data.Table0[0][nombrePaso]);
				if (valor) this.valor = valor;
			}
		},
		async guardar() {
			this.validar = true;
			this.$nextTick(async () => {
				if (this.valor) {
					const res = await ServicioVisita.guardarDieteticosEstiloVida(
						this.visitaId,
						this.valor
					);

					if (res.data.result === 1) {
						this.$router.back();
					} else {
						this.$root.mensajeError = res.data.message;
					}
				} else {
					this.$root.mensajeError =
						"Por favor llene los campos requeridos.";
				}
				this.validar = false;
			});
		},
		valorCambiado(valor) {
			if (valor) {
				this.valor = valor;
			}
		},
		regresar() {
			this.$router.back();
		}
	},
	computed: {
		visitaId() {
			return this.$route.params.visitaId;
		}
	}
};
</script>

<style></style>
